import { useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";

import { ActionKind } from "../../types/Action";
import { Dialog } from "../Dialog";
import * as svg from "./../svg";
import {
    RootStateKind,
    ScanSubStateKind,
    useRootState
} from "../state/StateProvider";

export const AgeVerificationDialog = () => {
    const { t } = useTranslation();
    const { state, dispatch } = useRootState(RootStateKind.Scan);

    useEffect(() => {
        const subState = state.subState;
        if (
            subState.kind === ScanSubStateKind.AgeVerification &&
            subState.status === "success"
        ) {
            const successTimeoutMs = 3000;

            const timeoutId = window.setTimeout(
                () =>
                    dispatch({
                        kind: ActionKind.AddProduct,
                        payload: subState.attemptedAction
                    }),
                successTimeoutMs
            );

            return () => clearTimeout(timeoutId);
        }
    }, [state]);

    if (state.subState.kind !== ScanSubStateKind.AgeVerification) {
        return null;
    }

    switch (state.subState.status) {
        case "success":
            return (
                <Dialog
                    image={svg.greenCheckmark}
                    title={t("verificationSuccessful")}
                ></Dialog>
            );
        case "unconfirmed":
            return (
                <Dialog
                    dataTestId="ageVerificationUnconfirmed"
                    image={<div className="mb-8">{svg.scanId}</div>}
                    title={t("ageVerification")}
                    primaryButton={{
                        title: t("cancel"),
                        action: () => dispatch({ kind: ActionKind.HideIdScan })
                    }}
                >
                    <>
                        <div>
                            <Trans i18nKey="scanId" />
                        </div>
                        <div className="bg-yellow-50 p-2 text-xs text-primary-900">
                            <Trans i18nKey="holdIdSteady" />
                        </div>
                    </>
                </Dialog>
            );
        case "underage":
            return (
                <Dialog
                    image={svg.eighteenPlus}
                    title={t("sorryCantSell")}
                    primaryButton={{
                        title: t("okDismiss"),
                        action: () => dispatch({ kind: ActionKind.HideIdScan })
                    }}
                >
                    <div>{t("sorryCantSellDescription")}</div>
                </Dialog>
            );
        case "invalidId":
            return (
                <Dialog
                    image={svg.productNotFound}
                    title={t("somethingWentWrong")}
                    primaryButton={{
                        title: t("okDismiss"),
                        action: () => dispatch({ kind: ActionKind.HideIdScan })
                    }}
                >
                    <div>{t("invalidId")}</div>
                </Dialog>
            );
        case "error":
            return (
                <Dialog
                    image={svg.productNotFound}
                    title={t("somethingWentWrong")}
                    primaryButton={{
                        title: t("okDismiss"),
                        action: () => dispatch({ kind: ActionKind.HideIdScan })
                    }}
                >
                    <div>{t("pleaseTryAgain")}</div>
                </Dialog>
            );
        default:
            return state.subState.status satisfies never;
    }
};
